import { DeliveryFunctionNetworkInterface } from 'data/deliveryFunctionNetworkInterface/deliveryFunctionNetworkInterface.types';
import { WithAuditDetails, AuditDetails, Operation } from 'data/types';
import {
  getAuditDetails,
  getAuditFieldInfo,
  AuditService,
  AuditActionType,
} from 'shared/userAudit/audit-constants';

export default function getNetworkDataToSubmit(
  network: DeliveryFunctionNetworkInterface,
  originalNetwork: DeliveryFunctionNetworkInterface | null,
  isAuditEnabled: boolean,
  userId: string,
  userName: string,
  operation: Operation,
): WithAuditDetails<DeliveryFunctionNetworkInterface> {
  const networkBody: WithAuditDetails<DeliveryFunctionNetworkInterface> = {
    data: network,
  };

  let actionType = AuditActionType.DELIVERY_FUNCTION_NETWORK_ADD;
  let isEdit = false;
  if (operation === 'UPDATE') {
    actionType = AuditActionType.DELIVERY_FUNCTION_NETWORK_EDIT;
    isEdit = true;
  }

  if (isAuditEnabled) {
    const auditDetails = getAuditDetails(
      isAuditEnabled,
      userId,
      userName,
      getAuditFieldInfo(network, null, isEdit, originalNetwork),
      network.interface,
      AuditService.NETWORK,
      actionType,
    );
    networkBody.auditDetails = auditDetails as AuditDetails;
  }

  return networkBody;
}
